import { GridType, GridsterConfig } from 'angular-gridster2';

// @dinamic
export const WidgetsHelper = {
  dashboardKey: '_____UserDashboard',

  defaultOptions: {
    cols: {
      max: 2,
      min: 1,
    },
    rows: {
      max: 2,
      min: 1,
    },
  },

  defaultConfigurations: [
    { key: 'size', name: 'Widget Size', type: 'select', options: null },
  ],

  defaultDashboard: [
    { cols: 2, rows: 1, y: 0, x: 0, meta: { name: 'HelloWorldWidgetComponent' } },
    { cols: 1, rows: 1, y: 2, x: 0, meta: { name: 'HelloWorldWidgetComponent' } },
    // tslint:disable-next-line:max-line-length
    { x: 0, y: 2, cols: 2, rows: 2, meta: { name: 'DatatableWidgetComponent', title: 'Datatable', description: 'Widget for rendering grids', icon: 'fa fa-table fa-4x' } },
  ],

  defaultGridConfiguration: (editable?: boolean) => {
    editable = Boolean(editable);
    const marginValue = editable ? 10 : 0;
    const margin = {
      margin: marginValue,
      outerMargin: editable,
      outerMarginTop: marginValue,
      outerMarginRight: marginValue,
      outerMarginBottom: marginValue,
      outerMarginLeft: marginValue,
    };
    const options: GridsterConfig = {
      editable,
      displayGrid: editable ? 'onDrag&Resize' : 'none',
      gridType: editable ? GridType.Fixed : GridType.Fit,
      minCols: 1,
      maxCols: 12,
      minRows: 1,
      maxRows: 40,
      setGridSize: false,
      fixedRowHeight: 100,
      fixedRowWidth: 100,
      ...margin,
      draggable: {
        enabled: editable,
        delayStart: 0,
        ignoreContent: editable,
        dragHandleClass: 'drag-handler',
        dropOverItems: editable,
      },
      resizable: {
        enabled: editable,
      },
      compactEnabled: editable,
      compactType: 'compactUp&Left',
      pushItems: editable,
      enableEmptyCellDrop: editable,
      emptyCellDragMaxCols: 5,
      emptyCellDragMaxRows: 4,
    };
    options.maxItemArea = Math.pow(options.emptyCellDragMaxCols * options.emptyCellDragMaxRows, 2) || 4 * 4;
    return options;
  },

  sanizeConfig: (configuration, reverse?: boolean) => {
    if (reverse) {
      configuration.meta.size = `${configuration.rows}x${configuration.cols}`;
    } else if (configuration.meta.size) {
      const size = configuration.meta.size.split('x');
      configuration.rows = Number(size[0]);
      configuration.cols = Number(size[1]);
      delete configuration.meta['size'];
    }
    return configuration;
  },

  generateSizeOptions: (config = WidgetsHelper.defaultOptions) => {
    const options = [];
    for (let row = config.rows.min; row <= config.rows.max; row++) {
      for (let col = config.cols.min; col <= config.cols.max; col++) {
        options.push(`${row}x${col}`);
      }
    }
    return options;
  },
};
